<h1 class="mf-popup-title" i18n="@@382326588571648">Izpis iz koledarja</h1>
<div class="m-portlet mf-portlet-gray__gray-background">
    <div class="m-portlet__body">
        <div class="m-content">
            <form *ngIf="mainForm" [formGroup]="mainForm" novalidate>
                <div class="row">
                    <div class="col-6">
                        <div class="m-portlet mb-0">
                            <div class="m-portlet__head">
                                <div class="m-portlet__head-caption">
                                    <div class="m-portlet__head-title">
                                        <h3 class="m-portlet__head-text" i18n="@@2841704621146112">Podizvjalci</h3>
                                    </div>
                                </div>
                            </div>
                            <div class="m-portlet__body mf-subcontractors-list">
                                <div class="m-checkbox-list">
                                    <label class="m-checkbox m-checkbox--state-brand">
                                        <input
                                            [checked]="isSelectedAll"
                                            (change)="onChangeSelect()"
                                            type="checkbox"
                                            i18n="@@0be9fda4-64f5-572b-8256-77fe2cd3b07c"
                                        />
                                        Označi vse
                                        <span></span>
                                    </label>
                                    <ng-container *ngFor="let subcontractorControl of mainForm.controls['items']['controls']; let i = index">
                                        <ng-container formArrayName="items">
                                            <label [formGroupName]="i" class="m-checkbox">
                                                <input (change)="isAllSelected()" type="checkbox" formControlName="selected" />
                                                <div class="fc-unthemed">
                                                    <span
                                                        [style.background]="subcontractorControl?.value?.data?.bgColor"
                                                        class="m-badge m-badge--dot"
                                                    ></span>
                                                    {{ subcontractorControl?.value?.data?.name }}
                                                </div>
                                                <span></span>
                                            </label>
                                        </ng-container>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="m-portlet mb-0">
                            <div class="m-portlet__head">
                                <div class="m-portlet__head-caption">
                                    <div class="m-portlet__head-title">
                                        <h3 class="m-portlet__head-text" i18n="@@3466347562401792">Časovni obseg</h3>
                                    </div>
                                </div>
                            </div>
                            <div class="m-portlet__body">
                                <div class="m-input-icon m-input-icon--left">
                                    <input
                                        [options]="options"
                                        (selected)="selectedDate($event, daterange)"
                                        type="text"
                                        name="daterangeInput"
                                        daterangepicker
                                        class="form-control m-input"
                                    />
                                    <span class="m-input-icon__icon m-input-icon__icon--left">
                                        <span>
                                            <i class="la la-calendar"></i>
                                        </span>
                                    </span>
                                </div>
                                <div class="mf-dashed-h mt-3 mb-3"></div>
                                <div>
                                    <button (click)="createReport()" class="btn btn-outline-accent m-btn m-btn--pill btn-block">
                                        <span>
                                            <span i18n="@@2897587046711296">Prikaži izpis</span>
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
<div class="modal-footer mf-custom-footer">
    <button
        (click)="activeModal.dismiss()"
        type="button"
        style="width: 150px"
        class="m-auto btn m-btn--pill btn-warning m-btn m-btn--custom"
        i18n="@@cancel"
    >
        Prekliči
    </button>
</div>
